import axios from 'axios';

export const apiUrl =
  process.env.REACT_APP_API_URL || 'http://localhost:5000';

export const TOKEN_KEY = '__token__';

export function getStoredToken() {
  return localStorage.getItem(TOKEN_KEY);
}

/** Unwrap legacy raw JSON or { status, data } envelope from backend. */
export function unwrapResponseData(payload) {
  if (
    payload &&
    typeof payload === 'object' &&
    typeof payload.status === 'string' &&
    payload.status.toLowerCase() === 'success' &&
    Object.prototype.hasOwnProperty.call(payload, 'data')
  ) {
    return payload.data;
  }
  return payload;
}

export function extractEnvelopeMessage(payload) {
  if (
    payload &&
    typeof payload === 'object' &&
    typeof payload.status === 'string' &&
    payload.status.toLowerCase() === 'success'
  ) {
    return payload.message || payload.msg || '';
  }
  return '';
}

export const apiClient = axios.create({
  baseURL: apiUrl,
  timeout: 100000,
});

apiClient.interceptors.request.use((config) => {
  const token = getStoredToken();
  if (token && !config.headers.authorization) {
    config.headers.authorization = `Bearer ${token}`;
  }
  return config;
});

apiClient.interceptors.response.use(
  (response) => {
    const envelopeMessage = extractEnvelopeMessage(response.data);
    if (envelopeMessage) {
      response.apiMessage = envelopeMessage;
    }
    response.data = unwrapResponseData(response.data);
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem(TOKEN_KEY);
      localStorage.removeItem('__user__:');
      if (window.location.pathname !== '/') {
        window.location.href = '/';
      }
    }
    const message =
      error.response?.data?.message ||
      error.response?.data?.msg ||
      error.message ||
      'Network error';
    return Promise.reject(new Error(message));
  }
);
